import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import api, {getApiErrorData} from "../../api";
import {Alert, Button, Card, Col, Form, Input, message, Row, Spin} from "antd";
import UpdateCard from "../../Components/UpdateCard";
import {useTranslations} from "../../lang";
import {pickUpSlotToHuman, printPrice} from "../../helpers";
import CdnImage from "../../Components/CdnImage";
import {DEFAULT_GUTTER} from "../../constants";
import ProfileHeader from "../../Components/ProfileHeader";
import OfferList from "../../Components/OfferList";

const Profile = () => {

    const {slug} = useParams()
    const [company, setCompany] = useState({});
    const [myCompany, setMyCompany] = useState({});
    const {translate} = useTranslations()
    const [pickUpSlots, setPickUpSlots] = useState([]);

    const cartFromStorage = localStorage.getItem('cart')
    const [cart] = useState(cartFromStorage ? JSON.parse(cartFromStorage) : {});

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cart))
    }, [cart]);

    useEffect(() => {

        if (api.isLoggedIn()) {
            api.getMyCompany().then(setMyCompany)
        }

        api.getCompanyBySlug(slug).then((c) => {
            // If this is an affiliate company, store UTM tags and redirect to homepage
            if (c.is_affiliate) {
                localStorage.setItem('utm_data', JSON.stringify({
                    utm_source: 'affiliate',
                    utm_medium: 'affiliate',
                    utm_campaign: String(c.id),
                    timestamp: Date.now(),
                }));
                window.location.href = '/';
                return;
            }

            setCompany(c)

            if (!c.is_published && !api.isLoggedIn()) {
                document.location = '/404'
                return
            }

            api.getPickUpSlots(c.id).then(setPickUpSlots)
        }).catch((error) => {
            if (getApiErrorData(error).detail === "CompanyNotFound") {
                document.location = '/404'
            }
        })
    }, [slug]);

    const subscribe = (values) => {
        api.subscribeToCompany(company.id, values.name, values.email).then(() => {
            message.success(translate('Je bent ingeschreven voor de updates!'))
        })
    }

    if (!company.id) {
        return <Spin/>
    }

    return (
        <div>
            {(myCompany?.id === company?.id && !myCompany.is_published) && (
                <Alert
                    description={translate('Je profiel pagina is nog niet gepubliceerd. Alleen jij kan deze pagina zien als je ingelogd bent.')}></Alert>
            )}

            <ProfileHeader company={company}/>



            <Card style={{background: 'white'}} className={"mar-b-1"}>
                <h1>{translate('Aanbod')}</h1>
                <OfferList company={company}/>
            </Card>

            <Card style={{background: 'white'}} className={"mar-b-1"}>
                <h1>Leveringsopties</h1>
                <Row gutter={DEFAULT_GUTTER}>
                    {company.is_delivery_enabled && (
                        <Col style={{flex: 1}}>
                            <Card style={{height: '100%'}}>
                                <h2>{translate('Bezorging')}</h2>
                                <p>{company.delivery_instructions}</p>
                                {company.delivery_free_range > 0 && (
                                    <p>We rekenen geen bezorgkosten binnen een straal
                                        van {company.delivery_free_range}km</p>
                                )}
                                <p>Voor een bezorging rekenen we {printPrice(company.delivery_base_price)} {
                                    (company.delivery_km_price > 0) &&
                                    <span>plus {printPrice(company.delivery_km_price)} per km</span>
                                }</p>
                                <p>In de winkelwagen worden automatisch de bezorgkosten berkend.</p>
                            </Card>
                        </Col>
                    )}
                    {company.is_on_appointment_enabled && (
                        <Col style={{flex: 1}}>
                            <Card style={{height: '100%'}}>
                                <h2>{translate('Op afspraak')}</h2>
                                <p>
                                    We spreken af wanneer je je bestelling kan komen ophalen. Een afspraak maken kan
                                    gemakkelijk via een bericht op Oogst.
                                    {company.is_phone_enabled && (
                                        <>Liever telefonisch? Dat is ook mogelijk, na betaling ontvang je het
                                            telefoonnummer van de verkoper.</>
                                    )}
                                </p>
                                {/*<Button>Stuur een bericht via Oogst</Button>*/}
                            </Card>
                        </Col>
                    )}
                    {company.is_stall_enabled && (
                        <Col style={{flex: 1}}>
                            <Card style={{height: '100%'}}>
                                <h2>{translate('Kraam aan de weg')}</h2>
                                <p>{company.stall_instructions}</p>
                            </Card>
                        </Col>
                    )}
                    {company.is_pickup_enabled && (
                        <Col style={{flex: 1}}>
                            <Card style={{height: '100%'}}>
                                <h2>{translate('Vaste afhaalmomenten')}</h2>
                                <p>In het bestelformulier kies je een datum en tijd waarop je de bestelling op komt
                                    halen.</p>
                                <p>{company.pickup_instructions}</p>
                                <p>De volgende afhaalmomenten zijn beschikbaar:</p>
                                <ul>
                                    {pickUpSlots.map((slot) => {
                                        return (<li key={`slot${slot.id}`}>{pickUpSlotToHuman(slot)}</li>)
                                    })}
                                </ul>
                            </Card>
                        </Col>
                    )}
                </Row>
            </Card>

            {company?.users?.length > 1 && (
                <Row className={"mar-b-1"}>
                    <Col md={24} xs={24}>

                        <Card style={{background: 'white', height: '100%'}}>
                            <h1>Ons Team</h1>
                            <Row>
                                {company?.users?.map(member => (
                                    <Col key={`user${member.id}`} md={6} xs={24} className={"text-center"}>
                                        <div className={"mar-b-1"} style={{fontSize: '1.5rem'}}>

                                            <h2 className={"mar-t-1"}>{member.name}</h2>
                                            {member.avatar && (
                                                <CdnImage src={member.avatar} width={150} height={150} style={{
                                                    display: 'inline-block',
                                                    width: '150px',
                                                    height: '150px',
                                                    objectFit: 'cover',
                                                    objectPosition: 'center',
                                                    borderRadius: '50%'
                                                }}></CdnImage>
                                            )}
                                            {!member.avatar && (
                                                <img
                                                    className={"mar-r-1"}
                                                    src={'/static/img/empty-avatar.png'}
                                                    alt={member.name}
                                                    style={{
                                                        display: 'inline-block',
                                                        width: '150px',
                                                        height: '150px',
                                                        objectFit: 'cover',
                                                        objectPosition: 'center',
                                                        borderRadius: '50%',
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Card>
                    </Col>
                </Row>
            )}
            <Card style={{background: 'white'}}>

                <h1>{translate('Updates')}</h1>
                <h2>{translate('Hieronder vind je de updates van')} {company?.name}</h2>

                {company?.updates && (

                    <div className={"mar-t-2"}>
                        <Row gutter={DEFAULT_GUTTER}>
                            <Col xs={24} md={8}>
                                <Card style={{height: '100%'}}>
                                    <h1>{translate('Inschrijven')}</h1>
                                    <p>{translate('Mis niks! Vul hieronder je emailadres in en je ontvangt alle updates per email van')} {company?.name}</p>

                                    <Form onFinish={subscribe}>
                                        <Form.Item name={"name"} rules={[
                                            {
                                                required: true,
                                                message: translate('Vul je naam in'),
                                            }
                                        ]}>
                                            <Input size={"large"} type={"text"}
                                                   placeholder={translate('Vul je naam in')}></Input>
                                        </Form.Item>
                                        <Form.Item name={"email"} rules={[
                                            {
                                                required: true,
                                                message: translate('Vul een (geldig) emailadres in'),
                                            },
                                            {
                                                type: 'email',
                                                message: translate('Vul een (geldig) emailadres in'),
                                            }
                                        ]}>
                                            <Input size={"large"} type={"email"}
                                                   placeholder={translate('Vul je emailadres in')}></Input>
                                        </Form.Item>
                                        <Form.Item>
                                            <Button size={"large"} htmlType={"submit"}
                                                    type={"primary"}>{translate('Inschrijven')}</Button>
                                        </Form.Item>
                                    </Form>
                                </Card>
                            </Col>
                            {company?.updates.map(update => (
                                <Col xs={24} sm={8} key={`update${update.id}`}>
                                    <UpdateCard key={`update_card${update.id}`} update={update}></UpdateCard>
                                </Col>
                            ))}
                        </Row>
                        {company?.updates.length === 0 && (
                            <p>{translate('Er zijn nog geen updates geplaatst. :-( Kom later terug.')}</p>
                        )}
                    </div>
                )}
            </Card>
        </div>
    );
}

export default Profile;